import { Material } from "three";
import { BeamVertical } from "../components/BeamVertical";
import { getGeometryBounds2D } from "../components/openingGeometry";
import type { OpdekGLTFResult } from "../opdek/OpdekType";
import type { VerticalBeamPosition } from "entities/configurator/model/layoutMeta";
import { standingDoorBeamInsetMeters } from "entities/configurator/model/layoutGeometry";
import {
  getLocalVerticalBeamX,
  getVerticalFrameEdges,
} from "./verticalLayoutUtils";
import { toOpdekLocalPosition } from "./opdekVerticalLayoutUtils";

export const OpdekVerticalLayout = ({
  nodes,
  material,
  width,
  height,
  semanticPosition,
}: {
  nodes: OpdekGLTFResult["nodes"];
  material: Material;
  width: number;
  height: number;
  semanticPosition: VerticalBeamPosition | undefined;
}) => {
  const isVisible = semanticPosition !== undefined;
  const leftBounds = getGeometryBounds2D(nodes.frame_left.geometry);
  const rightBounds = getGeometryBounds2D(nodes.frame_right.geometry);
  const topBounds = getGeometryBounds2D(nodes.frame_top.geometry);
  const bottomBounds = getGeometryBounds2D(nodes.frame_bottom.geometry);
  const beamBounds = getGeometryBounds2D(nodes.beam_vertical.geometry);

  const { left, right, top, bottom } = getVerticalFrameEdges({
    width,
    height,
    leftBounds,
    rightBounds,
    topBounds,
    bottomBounds,
  });
  const beamX = isVisible
    ? getLocalVerticalBeamX(
        toOpdekLocalPosition(semanticPosition),
        left,
        right,
        beamBounds,
        { insetMeters: standingDoorBeamInsetMeters },
      )
    : 0;

  return (
    <BeamVertical
      visible={isVisible}
      geometry={nodes.beam_vertical.geometry}
      material={material}
      x={beamX}
      bottom={bottom}
      top={top}
      scaleX={1}
    />
  );
};
